import { Appointment, AppointmentStatus } from "@rmh/defs";

export const canRescheduleAppointment = (appointment: Appointment) => {
  if (!appointment.appointmentDate) {
    console.error("Appointment date is required");
    return false;
  }

  if (appointment.appointmentStatus === AppointmentStatus.Completed) {
    return false;
  }

  return true;
};
